import React, { useState } from 'react'
import { FaFile } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import styles from './FileLabel.module.scss'
import pdfIcon from '../../assets/images/icon-pdf.png'
import Toggle from '../../components/Switch'
import { useDispatch } from 'react-redux';
import { toggleFileShared } from '../../actions/common';
import { IoIosEye } from "react-icons/io";
import { setPreview } from '../../actions/helper';

export default function FileLabel({
    fileName,
    imageMode,
    pdfMode,
    fileLink,
    onDelete,
    onClick,
    withoutLabel,
    shareValue,
    fileId
}) {

  const _pdfMode = pdfMode || fileLink?.toLowerCase().includes('pdf')
  const canPreview = _pdfMode || imageMode

  const dispatch = useDispatch()
  
  const [toggle, setToggle] = useState(!!shareValue)

  const setPreviewHandler = (e) => {
    e.stopPropagation()
    dispatch(setPreview(fileLink))
  }

  const deleteFile = (e) => {
    e.preventDefault()
    e.stopPropagation()
    onDelete()
  }

  const onToggleClick = async (e) => {
    e.stopPropagation()
    e.preventDefault()
    const newValue = !toggle
    const success = await dispatch(toggleFileShared(fileId, newValue))
    success && setToggle(newValue)
  }

  const fileClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (onClick) {
      onClick()
    } else if (fileLink) {
      const link = document.createElement('a')
      link.setAttribute('href', fileLink)
      link.setAttribute('target', 'blank')
      link.setAttribute('rel', 'noopener noreferrer')
      link.setAttribute('download', fileName)
      link.click()
    }
  }


  const icon = imageMode
    ? <div><img src={fileLink} alt="o_O"/></div>
    : _pdfMode
      ? <div><img src={pdfIcon} alt="o_O"/></div>
      : <i><FaFile size={56} className={styles.fileIcon}/></i>

  return (
    <div>
      <div
      onClick={fileClick}
      className={styles.fileBlock}
    >

      {icon}
      {!withoutLabel && <span>{fileName}</span>}
      <div className={styles.iconsBlock}>
        {!!canPreview && <IoIosEye className={styles.previewIcon} onClick={setPreviewHandler} />}
        {onDelete && <IoMdClose className={styles.deleteIcon} onClick={deleteFile}/>}
      </div>
    </div>
      {shareValue !== undefined && (
        <Toggle
          checked={toggle}
          onClick={onToggleClick}
          hint={`${toggle ? 'Опубликовано' : 'Опубликовать'} в методической копилке`}
        />
      )}
    </div>
  )
}
